// To do: Fix responsiveness of table and form
import { HStack, FormLabel, Input, useToast, Spacer } from "@chakra-ui/react";
import { useState } from "react";
import {
  convertGeocodeResultToGeoJSON,
  FeatureCollection,
} from "../../../components/mapcomponent/generic";
import PageComponent from "../../../components/PageComponent";
import ForwardGeocodeDocs from "../../../components/api-docs/ForwardGeocodeDocs";

export default function ForwardGeocode() {
  const [apiKey, setApiKey] = useState("");
  const [address, setAddress] = useState("");
  const [bounds, setBounds] = useState("");
  const [components, setComponents] = useState("");

  const [results, setResults] = useState<{
    apiResponse: string;
    geoJSON: FeatureCollection;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleCopy = () => {
    results &&
      results.apiResponse &&
      navigator.clipboard.writeText(results.apiResponse);
    toast({
      title: "Success!",
      description: "API response successfully copied to your clipboard",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  async function handleSubmit() {
    try {
      setIsLoading(true);
      var queryString = "";
      if (address !== "") {
        queryString = `address=${address}`;
      }
      if (bounds !== "") {
        queryString += `&bounds=${bounds}`;
      }
      if (components !== "") {
        queryString += `&components=${components}`;
      }

      const response = await fetch(
        `${process.env.REACT_APP_V1_API_SERVER_ENDPOINT}/geocode/forward?${queryString}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": apiKey,
          },
        },
      );

      if (response.status === 401) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "Please provide a valid API key",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      if (response.status !== 200) {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "Error!",
          description: "There was an error fetching data",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const data = await response.json();
      console.log("Data:", data);
      if (data.results && data.results.length >= 1) {
        toast({
          title: "Success!",
          description: "Geocoding successfully completed",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        setIsLoading(false);
        setResults(null);
        toast({
          title: "No results!",
          description: "Geocoding did not return any results.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      setResults({
        apiResponse: JSON.stringify(data, null, 2),
        geoJSON: convertGeocodeResultToGeoJSON(data.results),
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setResults(null);
      console.log(error);
      toast({
        title: "Error!",
        description: "There was an error fetching data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <PageComponent
      navItemsV1={[
        { title: "Forward Geocode API", nav: "api" },
        { title: "Try out the API", nav: "playground" },
        { title: "API Documentation", nav: "documentation" },
        { title: "Base URL", nav: "baseurl" },
        { title: "Endpoint", nav: "endpoint" },
        { title: "Authentication", nav: "authentication" },
        { title: "Headers", nav: "headers" },
        { title: "Request Parameters", nav: "requestparameters" },
        { title: "Request Examples", nav: "requestexamples" },
        { title: "Response Body", nav: "responsebody" },
        { title: "Response Field Reference", nav: "responsefields" },
        { title: "Example Requests", nav: "examplerequests" },
        { title: "Status Codes", nav: "statuscodes" },
        { title: "Notes", nav: "notes" },
      ]}
      handleCopy={handleCopy}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      isDisabled={!address || !apiKey}
      result={results}
      documentationComponent={<ForwardGeocodeDocs />}
      formComponent={
        <>
          <HStack>
            <FormLabel pb={0} mb={0}>
              API Key
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter API key"
              borderColor={"#bcbcbc"}
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Address
            </FormLabel>{" "}
            <Spacer />
            <Input
              isRequired
              type="text"
              w="3fr"
              placeholder="Enter address"
              borderColor={"#bcbcbc"}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Bounds
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="1.30,103.93|1.31,103.94"
              borderColor={"#bcbcbc"}
              value={bounds}
              onChange={(e) => setBounds(e.target.value)}
            />
          </HStack>
          <HStack>
            <FormLabel pb={0} mb={0}>
              Components
            </FormLabel>{" "}
            <Spacer />
            <Input
              type="text"
              w="3fr"
              placeholder="country:SG|postal_code:449891"
              borderColor={"#bcbcbc"}
              value={components}
              onChange={(e) => setComponents(e.target.value)}
            />
          </HStack>
        </>
      }
      headerTitle={"Forward Geocode"}
      headerPath={"v1/geocode/forward"}
      headerDescription={
        "Convert a human-readable address into geographic coordinates and structured place information. Returns one or more matching locations ordered by relevance."
      }
    />
  );
}
